import { useEffect, useState } from 'react';
import { PRICES_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';

const usePriceItem = ({ price }) => {
  const { Widget } = window;
  const [state, setState] = useState({
    selectedPrices: Widget.pricesController.selectedPrices,
  });

  const togglePriceListener = () =>
    setState({ selectedPrices: Widget.pricesController.selectedPrices });
  useEffect(() => {
    Widget.pricesController.addListener(PRICES_EVENTS.TOGGLE_PRICE, togglePriceListener);
    return () => {
      Widget.pricesController.removeListener(PRICES_EVENTS.TOGGLE_PRICE, togglePriceListener);
    };
  }, []);

  const togglePrice = () => {
    if (!Widget.zoomController.isZooming) {
      Widget.pricesController.togglePrice(price.index);
    }
  };

  const index = Widget.pricesController.pricesIndexes[price.value];
  const isSelected = state.selectedPrices.has(index);

  return { togglePrice, isSelected };
};

export default usePriceItem;
